import { render, staticRenderFns } from "./StepIdentityConfirm.vue?vue&type=template&id=a483af40&scoped=true&"
import script from "./StepIdentityConfirm.vue?vue&type=script&lang=js&"
export * from "./StepIdentityConfirm.vue?vue&type=script&lang=js&"
import style0 from "./StepIdentityConfirm.vue?vue&type=style&index=0&id=a483af40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a483af40",
  null
  
)

export default component.exports